module.exports = __webpack_public_path__ + "img/one.298a46b5.png";